import styles from './LoginHeader.module.css';

const LoginHeader = ({ text, active }) => {
  const isActive = active ? `${styles.active}` : `${styles.inactive}`;

  return <div className={`${styles.header} ${isActive}`}>{text}</div>;
};

LoginHeader.defaultProps = {
  active: '',
};

export default LoginHeader;
